import queryString from 'query-string';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Alert } from 'pages/SignIn/components/Alert';
import { Content } from 'pages/SignIn/components/Content';
import { Footer } from 'pages/SignIn/components/Footer';
import { Title } from 'pages/SignIn/components/Title';
import { SignInPageController } from 'pages/SignIn/machine';
import { AuthFormWrapper } from 'utils/form.styles';

function SignInPageContent(): JSX.Element {
  const actor = SignInPageController.useActorRef();

  return (
    <AuthFormWrapper
      onSubmit={(event) => {
        event.preventDefault();
        actor.send({ type: 'Submit Form' });
      }}
      autoComplete="off"
    >
      <Title />
      <Alert />
      <Content />
      <Footer />
    </AuthFormWrapper>
  );
}

export function SignInPage({
  isUnlockAccount = false
}: {
  isUnlockAccount?: boolean;
}): JSX.Element {
  const [, { language }] = useTranslation();
  const location = useLocation();
  const { token: unlockAccountToken } = queryString.parse(location.search);

  return (
    <SignInPageController.Provider
      options={{
        context: {
          email: '',
          password: '',
          otp: '',
          isOtpRequired: false,
          data: null,
          errorData: null,
          isUnlockAccount,
          locale: language,
          unlockAccountToken
        }
      }}
    >
      <SignInPageContent />
    </SignInPageController.Provider>
  );
}
